export default __webpack_public_path__ + "static/media/Version (5) - Deathly Hallows_05.11fc803e.jpg";